import React, { useState, useEffect, useContext } from 'react';
import Moment from 'moment-timezone';
import { ScreenContext } from '../contexts/ScreenContext';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';


const Timezone = React.memo(() => {

    const [ time, setTime ] = useState(Moment(new Date())); 
    const { isDesktop } = useContext(ScreenContext); 

    const getTimeDiff = (time) => {
      let OtherTime = time.parseZone().utcOffset();
      let DaytonTime = Moment(new Date()).tz('America/New_York').parseZone().utcOffset();
      let timeDiff = ((DaytonTime - OtherTime)/60) * -1;

      timeDiff = timeDiff.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      })

      timeDiff = (timeDiff > 0) ? `+${timeDiff}` : timeDiff 

      return  timeDiff;
    }

    useEffect(()=>{
      
      let unmounted = false;

      setTimeout(() => {
        if(!unmounted) {
          setTime(Moment(new Date()));
        }
      }, 1);

      return () => {            
        unmounted = true;        
      }  
    }, [time]);

    return(
        <React.Fragment>
            <Typography noWrap variant="h6" align="left" display="block">{`TIMEZONES`}</Typography>
            <Grid container spacing={0}>
              <Grid item xs={4}><Typography noWrap style={{lineHeight:1.7}}  variant="overline" align="left" display="block">{`Huntsville`}</Typography></Grid>
              <Grid item xs={8}><Typography noWrap style={{lineHeight:1.7}}  variant="overline" align="right" display="block">{`${time.tz('America/Chicago').format(`HH:mm:ss z [${getTimeDiff(time.tz('America/Chicago'))}]`)}`}</Typography></Grid>
              <Grid item xs={4}><Typography noWrap style={{lineHeight:1.7}}  variant="overline" align="left" display="block">{`Chicago`}</Typography></Grid>
              <Grid item xs={8}><Typography noWrap style={{lineHeight:1.7}}  variant="overline" align="right" display="block">{`${time.tz('America/Chicago').format(`hh:mm:ss a z [${getTimeDiff(time.tz('America/Chicago'))}]`)}`}</Typography></Grid>
              <Grid item xs={4}><Typography noWrap style={{lineHeight:1.7}}  variant="overline" align="left" display="block">{`Kuwait`}</Typography></Grid>
              <Grid item xs={8}><Typography noWrap style={{lineHeight:1.7}}  variant="overline" align="right" display="block">{`${time.tz('Asia/Kuwait').format(`hh:mm:ss a [KWT] [${getTimeDiff(time.tz('Asia/Kuwait'))}]`)}`}</Typography></Grid>
            </Grid>
            <Typography noWrap variant="overline" align="right" display="block">
              <Link href={`https://www.timeanddate.com/worldclock/meetingtime.html?iso=${time.tz('Asia/Kuwait').format('YYYYMMDD')}&p1=810&p2=123`} target="_blank">
                {(isDesktop) ? `What is a good time to meet?` : `Good time to meet?`}
              </Link>
            </Typography>
        </React.Fragment>
    );
});

export default Timezone;
